import { clsx } from 'clsx'

import { Flex } from '@buffer-mono/popcorn'

import { CommentMediaAsset } from './CommentMediaAsset'
import { useCommentData } from '../context/CommentContext'

import styles from './CommentMedia.module.css'

type CommentMediaProps = {
  className?: string
}

export const CommentMedia = ({
  className,
}: CommentMediaProps): JSX.Element | null => {
  const comment = useCommentData()

  if (!comment.assets?.length) return null

  return (
    <Flex className={clsx(styles.assets, className)} gap="2xs">
      {comment.assets.map((asset) => (
        <CommentMediaAsset key={asset.id} asset={asset} />
      ))}
    </Flex>
  )
}
